var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: " 0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.7) translate(-6.57 -6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 2.067 2.067 0.5 4 0.5H31.5V31.5H4C2.067 31.5 0.5 29.933 0.5 28V4Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0919 11.0912L12.25 8.5L11.4081 11.0912H8.68354L10.8877 12.6926L10.0458 15.2838L12.25 13.6824L14.4542 15.2838L13.6123 12.6926L15.8165 11.0912H13.0919Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4468 11.5C17.0829 8.95578 14.8949 7 12.25 7C9.35051 7 7 9.35051 7 12.25C7 14.8949 8.95578 17.0829 11.5 17.4468V23.7727C11.5 24.394 12.1136 25 12.7273 25H23.7727C24.3864 25 25 24.394 25 23.7727V12.7273C25 12.1136 24.394 11.5 23.7727 11.5H17.4468ZM16.75 12.25C16.75 14.7353 14.7353 16.75 12.25 16.75C9.76472 16.75 7.75 14.7353 7.75 12.25C7.75 9.76472 9.76472 7.75 12.25 7.75C14.7353 7.75 16.75 9.76472 16.75 12.25ZM12.7273 17.4786C12.5701 17.4928 12.4109 17.5 12.25 17.5C12.2044 17.5 12.159 17.4994 12.1136 17.4983V23.7727C12.1136 24.0795 12.4205 24.3864 12.7273 24.3864H23.7727C24.0795 24.3864 24.3864 24.0795 24.3864 23.7727V12.7273C24.3864 12.4205 24.0795 12.1136 23.7727 12.1136H17.4983C17.4994 12.159 17.5 12.2044 17.5 12.25C17.5 12.4109 17.4928 12.5701 17.4786 12.7273H23.1591C23.4659 12.7273 23.7727 13.0341 23.7727 13.3409V21.9318L20.0909 18.25L18.8636 19.4773L17.0227 17.0227L12.7273 21.9318V17.4786ZM22.4688 14.875C22.4688 15.574 21.9021 16.1406 21.2031 16.1406C20.5041 16.1406 19.9375 15.574 19.9375 14.875C19.9375 14.176 20.5041 13.6094 21.2031 13.6094C21.9021 13.6094 22.4688 14.176 22.4688 14.875Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopImages);
export default __webpack_public_path__ + "static/media/TopImages.79c9d0ba3659120e70d43c3eba76cd96.svg";
export { ForwardRef as ReactComponent };